export const menuSectionTypes = {
  MENU: 'MENU',
  CLAUSE: 'CLAUSE',
  SECTION: 'SECTION',
  SUBSECTION: 'SUBSECTION',
  PRODUCT: 'PRODUCT'
};
